import React from 'react'
import { Container, BoxTextos, Titulo, Texto, BoxImagem, Imagem } from './Styled'
import bgCoachingDesktop from 'images/black-friday-2025/bg-coaching.jpg'
import imgCoaching from 'images/black-friday-2025/coaching.png'
import { date } from 'utils/formatters'

export default function Coaching ({ desconto, dataFim }) {
	return (
		<Container bgDesktop={bgCoachingDesktop}>
			<BoxTextos>
				<Titulo>Ganhe até 6 meses de acesso grátis +<br></br> até 2 meses de coaching exclusivo!</Titulo>
				<Texto>Durante a Black Friday, além de garantir sua assinatura com até {desconto}% OFF, você ainda leva até 6 meses de acesso grátis para estudar mais tempo sem pagar nada a mais. E não para por aí: você também ganha até 2 meses de coaching com nossos especialistas, que vão criar um plano de estudos estratégico e personalizado para você, ajudando a evitar erros comuns e acelerar sua aprovação.</Texto>
				<Texto>👉 Oferta válida somente até {date(dataFim)}.</Texto>
			</BoxTextos>
			<BoxImagem>
				<Imagem src={imgCoaching} />
			</BoxImagem>
		</Container>
	)
}
